module.exports = __webpack_public_path__ + "static/media/advertisers_m_2.a777f5d8.png";